import { useTranslation } from "react-i18next";
import { useState } from "react";
import Button from "components/button/default";
import CheckBox from "components/chexkbox";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { IOutletContext } from "../layout";
import PayInf from "../inf/payInf";

type IProps = {
  cnlResvInf: any;
  handleResvCancel(): void;
};

export default function CancelInf({ cnlResvInf, handleResvCancel }: IProps) {
  const { t } = useTranslation();
  const { resvStat } = useOutletContext<IOutletContext>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [checked, setChecked] = useState(false);

  const [item, setItem] = useState("");

  const payInf = {
    resvAmt: cnlResvInf?.resvAmt,
    payAmt: cnlResvInf?.payAmt,
    payStaCd: cnlResvInf?.payStaCd,
    payStaNm: cnlResvInf?.payStaNm,
    dscAmt: cnlResvInf?.dscAmt, // 할인 금액
    sellAmt: cnlResvInf?.sellAmt,
    cnlFeeAmt: cnlResvInf?.cnlFeeAmt,
  };

  return (
    <div className="book-rm-inf">
      <h2 className="text-blue-300 ">
        {resvStat !== "cancel" ? t("ttl_dtl_mpg") : t("ttl_bk_dtl_mpg")}
      </h2>
      <div className="cancel-inf">
        <h3 className="sub between-center">
          <span>{cnlResvInf?.rmNm}</span>
          <div className="">
            <input
              type="checkbox"
              id={"rmPdNo"}
              name="rmPdNo"
              value={cnlResvInf?.rmNo}
              onChange={(e) => {
                if (e.currentTarget.checked) {
                  //객실 선택
                  setItem(e.currentTarget.value);
                }
                if (!e.currentTarget.checked) {
                  setItem("");
                }
              }}
            />
            <label htmlFor="rmPdNo"></label>
          </div>
        </h3>
        <ul>
          <li>
            <h5>{t("txt_rm_typ_cmm")}</h5>
            <h5>{cnlResvInf?.rmTypNm}</h5>
          </li>
          <li>
            <h5>{t("txt_gst_nm_cmm")}</h5>
            <h5>
              {t("txt_adlt_bk")}&nbsp;{cnlResvInf?.adltPerCt}&nbsp;/&nbsp;
              {t("txt_chld_bk")}&nbsp;{cnlResvInf?.chldPerCt}
            </h5>
          </li>
          <li>
            <h5>{t("txt_op_cmm")}</h5>
            <h5>{t("txt_nan_bk")}</h5>
          </li>
          <li>
            <h5>{t("txt_fr_prd_cmm")}</h5>
            <h5>---</h5>
          </li>
        </ul>
      </div>

      <PayInf payInf={payInf} />
      <div className="noti-inf">
        <CheckBox
          label={t("chckbx_lbl_cncl_bk_mpg")}
          name={""}
          id={"cancel"}
          onChange={(e) => {
            setChecked(e.currentTarget.checked);
          }}
        />
      </div>
      <div className="between-center">
        <Button
          text={t("btn_lst_cmm")}
          styels="bg-white h-54 w-[112px] font-18 "
          onClick={() => {
            navigate("/mypage/resv");
          }}
        />
        {pathname.includes("cancel") && (
          <Button
            text={t("btn_cncl_bk_mpg")}
            styels="h-54 px-6  font-18"
            disabled={!(checked && !!item)}
            onClick={handleResvCancel}
          />
        )}
      </div>
    </div>
  );
}
